<template>
  <div>
    <div
      v-show="!startScanningArticles"
    >
      <div
        style="display:flex;justify-content:space-between;align-items: center;border:1px solid #EAE9EA;border-top: transparent;padding: 0px 10px 10px 10px;"
      >
        <p style="margin-bottom: 0px;font-weight: 600;">
          {{ $t('DoYouWantToStartAcceptanceOfOrder') }}
        </p>
        <b-form-group
          :label="$t('Location')"
          style="width:20%"
        >
          <vue-select
            v-model="locationName"
            :options="getLocationByPagination"
            :placeholder="$t('Select')"
            label="locationName"
            :clearable="false"
            style="width:100%"
          />
          <p
            v-if="locationName == null"
            style="color:red;"
          >
            {{ $t('SelectLocation') }}
          </p>
        </b-form-group>
      </div>
      <b-form-group
        :label="$t('Notes')"
        style="width:60%;margin-top:10px;"
      >
        <b-form-textarea
          v-model="notes"
          :placeholder="$t('Write...')"
          style="min-height:100px;"
        />
      </b-form-group>
      <button
        class="primary"
        :disabled="locationName == null"
        style="margin-top: 15px;;"
        @click="startScanningArticle"
      >
        {{ $t('ClickToStartLocation') }}
      </button>
    </div>
    <div v-show="startScanningArticles">
      <div style="display:flex;gap:15px;align-items:center;justify-content: center;margin-top: 10px;margin-bottom:10px;">
        <h2 style="text-align:center;margin-bottom:0px;">
          {{ $t('Order') }} {{ orderUnique?.orderNumber }}, {{ $t('AcceptanceDate') }}: {{ acceptanceDate }}, {{ $t('Location') }}: {{ locationName?.locationName }}
        </h2>
        <b-tooltip
          target="save-icon"
          placement="top"
        >
          {{ $t('SaveOrder') }}
        </b-tooltip>
        <b-icon
          id="save-icon"
          icon="save"
          scale="1.5"
          style="cursor: pointer; color: green;"
          @click="stopScanningArticle"
        />
      </div>
      <div v-show="scanArticle">
        <video
          ref="video"
          style="width: 100%; height: auto"
        />
      </div>
      <button
        v-if="scanArticle"
        class="button"
        @click="removeScanner"
      >
        {{ $t('RemoveScanner') }}
      </button>
      <div style="display:flex;justify-content: space-between;align-items: end;">
        <button
          v-if="!scanArticle"
          class="button"
          :disabled="loadingScanned"
          @click="addScanner"
        >
          {{ $t('ScanArticle') }}
        </button>
        <button
          v-if="!scanArticle"
          v-b-modal.add-files-acceptance-modal
          class="button"
        >
          {{ $t('AddFiles') }}
        </button>
      </div>
      <div
        v-if="loadingScanned"
        style="display:flex;gap:5px;margin-top: 10px;"
      >
        <div
          class="spinner-border spinner-border-sm"
        />
        <p style="font-weight:600;">
          {{ $t('AddingScannedProduct') }}
        </p>
      </div>
      <p style="font-weight:600;color:black;margin-top: 5px; margin-bottom: 0px;">
        {{ scannedArticle }}
      </p>
      <div style="display:flex;gap:5px">
        <p style="font-weight:600;color:black;margin-top: 5px; margin-bottom: 0px;">
          {{ textFromScanner }}
        </p>
        <button
          v-if="textFromScanner !== ''"
          v-b-modal.add-article-order-modal
          class="button"
        >
          {{ $t('AddManually') }}
        </button>
      </div>
      <div>
        <table
          class="team_table"
          style="margin-top:10px;"
        >
          <thead>
            <tr>
              <th>
                {{ $t('No') }}
              </th>
              <th>
                {{ $t('ArticleNumber') }}
              </th>
              <th>
                {{ $t('Barcode') }}
              </th>
              <th>
                {{ $t('Quantity') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in articleList"
              :key="index"
            >
              <td>
                {{ index + 1 }}.
              </td>
              <td>
                {{ item.articleNumber }}
              </td>
              <td>
                {{ item.barcode }}
              </td>
              <td>
                {{ item.quantity }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ArticlesOverviewModal
        @addToDirect="addToDirectBarcode"
      />
      <AddFilesAcceptance
        :order-unique="orderUnique"
        @addFilesDeliveryModal="addFilesDeliveryManagement"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { BrowserMultiFormatReader } from '@zxing/library';
import moment from 'moment'
import Swal from 'sweetalert2';
import 'vue2-datepicker/index.css';
import ArticlesOverviewModal from '@/components/PurchaseArticles/AddArticlesModals/ArticlesOverviewModal.vue';
import AddFilesAcceptance from '@/components/productsInStock/modals/AddFilesAcceptance.vue';

export default {
  components: {
    ArticlesOverviewModal,
    AddFilesAcceptance,
  },
  props: [],
  data() {
    return {
      notes: null,
      locationName: null,
      acceptanceDate: moment().format('YYYY-MM-DD'),
      textFromScanner: '',
      responseText: '',
      scannedArticle: '',
      loadingScanned: false,
      isScanning: true,
      scanArticle: false,
      startScanningArticles: false,
      articleList: [],
      codeReader: null,
      videoStream: null,
      orderUnique: null,
    };
  },
  computed: {
    ...mapGetters([
      'getLocationByPagination',
    ]),
  },
  watch: {

  },
  mounted() {
    this.locationPagination({
      storeId: null,
    })
  },
  methods: {
    ...mapActions([
      'loadArticleByScanner',
      'locationPagination',
      'startDeliveryGoods',
      'acceptArticleScanner',
      'addFilesDelivery',
    ]),
    addFilesDeliveryManagement(value) {
      this.addFilesDelivery({
        object: value,
      })
    },
    startScanningArticle() {
      const object = {
        receiverLocationId: this.locationName.locationId,
        notes: this.notes,
      }
      this.startDeliveryGoods({
        object,
      }).then((response) => {
        this.startScanningArticles = true;
        this.orderUnique = response
      })
    },
    stopScanningArticle() {
      this.scanArticle = false
      this.isScanning = true;
      this.scannedArticle = ''
      this.textFromScanner = '';
      this.startScanningArticles = false;
      this.articleList = []
      this.locationName = null
      this.notes = null
      Swal.fire({
        icon: 'success',
        title: `${this.$t('Order')} ${this.orderUnique?.orderNumber} ${this.$t('SavedSuccessF')}`,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 1500,
      });
      this.stopScanner();
    },
    addToDirectBarcode(value) {
      this.articleList.push({
        articleNumber: `${value.articleName}`,
        barcode: `${value.barcode}`,
        inventoryProductId: null,
        quantity: 1,
        productInStockId: null,
      })
      this.textFromScanner = ''
    },
    addScanner() {
      this.scanArticle = true;
      this.isScanning = false;
      this.scannedArticle = '';
      this.textFromScanner = '';
      this.startScanner();
      // const barcodes = ['123421', '42134213', '421342132', '2414213213', '123'];
      // const randomBarcode = barcodes[Math.floor(Math.random() * barcodes.length)];
      // this.searchByBarcodeScanner(randomBarcode);
    },
    removeScanner() {
      this.scanArticle = false
      this.isScanning = true;
      this.scannedArticle = ''
      this.textFromScanner = '';
      this.stopScanner();
    },
    startScanner() {
      const codeReader = new BrowserMultiFormatReader();
      this.codeReader = codeReader;
      const videoElement = this.$refs.video;

      // Continuously scan the video stream
      codeReader
        .decodeFromVideoDevice(null, videoElement, (result, err) => {
          if (result) {
            this.onDecode(result.getText());
          }
          if (err && err.name !== 'NotFoundException') {
            console.error(err);
          }
        });

      // Start camera stream
      navigator.mediaDevices
        .getUserMedia({
          video: { facingMode: { exact: 'environment' } },
        })
        .then((stream) => {
          this.videoStream = stream;
          videoElement.srcObject = stream;
        })
        .catch((error) => {
          console.error('Error accessing camera:', error);
        });
    },
    stopScanner() {
      if (this.codeReader) {
        this.codeReader.reset();
      }

      if (this.videoStream) {
        const tracks = this.videoStream.getTracks();
        tracks.forEach((track) => { return track.stop() });
      }
      this.videoStream = null;
    },
    onDecode(text) {
      if (this.isScanning) {
        return;
      }
      this.isScanning = true;

      this.searchByBarcodeScanner(text)
    },
    onLoaded() {
      console.log('Ready to start scanning barcodes')
    },
    async searchByBarcodeScanner(value) {
      this.scanArticle = false;
      this.loadingScanned = true
      this.loadArticleByScanner({
        barcode: value,
      }).then((response) => {
        this.responseText = response
        if (!response || (Object.keys(response).length === 0 && response.constructor === Object)) {
          this.textFromScanner = `${this.$t('ThisProductNotRegistered')}`
          this.scanArticle = false;
          this.loadingScanned = false
          this.stopScanner();
        } else {
          const object = {
            inventoryProductId: response.inventoryId,
            receiverLocationId: this.locationName.locationId,
            articleNumber: response.articleNumber,
            quantity: 1,
            deliveryManagementId: this.orderUnique?.id,
          }
          const duplicate = this.articleList.find((article) => {
            return article.inventoryProductId === response.inventoryId;
          });
          if (duplicate) {
            this.scannedArticle = `${this.$t('ArticleNumber')}: ${response.articleNumber}; ${this.$t('Barcode')}: ${value}`
            duplicate.quantity += 1;
            this.acceptArticleScanner({
              object,
              successCallback: () => {
                this.loadingScanned = false
                this.scanArticle = false;
                this.stopScanner();
              },
            })
            this.loadingScanned = false
            this.scanArticle = false;
            this.stopScanner();
            return;
          }
          this.acceptArticleScanner({
            object,
            successCallback: () => {
              this.articleList.unshift({
                articleNumber: `${response.articleNumber}`,
                barcode: `${value}`,
                inventoryProductId: response.inventoryId,
                quantity: 1,
              });
              this.scanArticle = false;
              this.loadingScanned = false
              this.scannedArticle = `${this.$t('ArticleNumber')}: ${response.articleNumber}; ${this.$t('Barcode')}: ${value}`
              this.stopScanner();
            },
          })
          this.loadingScanned = false
          this.stopScanner();
        }
      }).catch((error) => {
        console.error('Error scanning barcode:', error);
      });
    },
  },
};
</script>

      <style scoped lang="scss">
        .team_table td {
          padding: 16px 9px !important;
        }
        .dropdrop {
          display: inline-block;
          overflow: auto;
          position: absolute;
          background: white;
          width: 227px;
          box-shadow: none;
          z-index:3;
        }

        input[name="search-box"] {
            display: block;
            max-width: 500px;
            width: 95%;
            padding: 0.5rem 1rem;
            padding-left: 25px;
        }
        .search-item {
            padding: 5px;
            max-width: 500px;
            width: 100%;
            font-weight: 400;
            color: #82868c;
            font-size: 1rem;
            border-bottom: 1px solid #e8e8e8;
        }
        .active2 {
          font-weight: bold;
          color: $base-color;
        }
        </style>
